module.exports = __webpack_public_path__ + "article.9a3281d5.png";